import React from 'react';
import Link from 'next/link';
import * as PropTypes from 'prop-types';

const CustomLink = ({
  href, as, className, target, children, ...other
}) => (
  <Link
    href={href}
    as={as}
    {...other}
  >
    <a {...(target ? {target} : {})} className={className}>{children}</a>
  </Link>
);

CustomLink.propTypes = {
  href: PropTypes.string,
  as: PropTypes.string,
  className: PropTypes.string,
  target: PropTypes.oneOf(['', '_blank', '_parent', '_top']),
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.node,
  ]),
};

CustomLink.defaultProps = {
  href: '/',
  as: '/',
  className: '',
  target: '',
  children: {},
};

export default CustomLink;
